// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'

import {
  CAT_SET_AMBITO_SELECTED,
  CATALOGOS_ADD_LISTA_SELECCION,
  CATALOGOS_ADD_LISTA_SELECCION_DATA,
  CATALOGOS_GET_ESTADO,
  CATALOGOS_GET_LISTASELECCION,
  CATALOGOS_NEW_LISTA_SELECCION,
  CATALOGOS_SET_ESTADO,
  CATALOGOS_SET_ID_NOMBRE,
  CATALOGOS_SET_IS_NEW,
  CATALOGOS_SET_LISTASELECCION,
  CATALOGOS_SET_LISTASELECCION_DATA,
  CATALOGOS_SET_RESERVAS_WIZZARD,
} from './CatalogosTypes'

import { RootState } from '../store'

import { postListaSeleccion } from '@/common/helpers/apiCatalogo'
import { notifications } from '@/common/helpers/notifications'
import { getAllListaSeleccion, getEstados, getReservasWizzard } from '@/common/helpers/odataApiServices'
import { agruparCatalogos, idNombre } from '@/common/helpers/utils'
import { Action } from '@/common/interfaces/general'
import { invalidarListaSeleccion } from '@/common/services/invalidarCatalogos'

/** revisar en LayoutSaga y ver si se elimina este proceso */
function* getCatalogoListaSeleccion(): Generator {
  try {
    const listaSeleccion = yield call(getAllListaSeleccion)

    yield put({
      type: CATALOGOS_SET_LISTASELECCION_DATA,
      payload: listaSeleccion.value,
    })
    const listaSeleccionAgrupado = yield call(agruparCatalogos, listaSeleccion.value)

    yield put({
      type: CATALOGOS_SET_LISTASELECCION,
      payload: listaSeleccionAgrupado,
    })
  } catch (error) {
    notifications({ ex: error })
  }
}

function* getCatalogoEstados(): Generator {
  try {
    const estados = yield call(getEstados)
    const estadosAgrupado = yield call(agruparCatalogos, estados.value)

    yield put({ type: CATALOGOS_SET_ESTADO, payload: estadosAgrupado })

    // Generar reservasWizzard e idEstadoNombre
    const reservasWizzard = yield call(getReservasWizzard, estadosAgrupado)

    yield put({
      type: CATALOGOS_SET_RESERVAS_WIZZARD,
      payload: reservasWizzard,
    })

    const idEstadoNombre = yield call(idNombre, estados.value, reservasWizzard)

    yield put({
      type: CATALOGOS_SET_ID_NOMBRE,
      payload: idEstadoNombre,
    })
  } catch (error) {
    notifications({ ex: error })
  }
}

function* postNewListaSeleccion({ payload }: Action<any>): any {
  const { listaSeleccion } = yield select((state: RootState) => state.Catalogos)

  try {
    const resp = yield call(postListaSeleccion, payload)
    const { Ambito, Descripcion, Eliminado, FechaCreacion, ListaSeleccionId, Nombre, Valor } = resp

    // Igual que al editar y al eliminar: la cache de los combos no ve este alta.
    yield put(invalidarListaSeleccion(Ambito))
    yield put({ type: CAT_SET_AMBITO_SELECTED, payload: Ambito })
    const newListaSeleccion = {
      [Ambito]: {
        [Nombre]: {
          Ambito,
          Descripcion,
          Eliminado,
          FechaCreacion,
          ListaSeleccionId,
          Nombre,
          Valor,
        },
      },
    }

    if (listaSeleccion[Ambito]) {
      listaSeleccion[Ambito][Nombre] = {
        Ambito,
        Descripcion,
        Eliminado,
        FechaCreacion,
        ListaSeleccionId,
        Nombre,
        Valor,
      }

      yield put({
        type: CATALOGOS_SET_LISTASELECCION,
        payload: listaSeleccion,
      })
    } else {
      yield put({
        type: CATALOGOS_ADD_LISTA_SELECCION,
        payload: newListaSeleccion,
      })
    }

    const newListaSeleccionData = {
      Ambito,
      Descripcion,
      Eliminado,
      FechaCreacion,
      ListaSeleccionId,
      Nombre,
      Valor,
    }

    yield put({
      type: CATALOGOS_ADD_LISTA_SELECCION_DATA,
      payload: newListaSeleccionData,
    })

    notifications({
      title: 'Nuevo catálogo',
      message: 'Se ha creado un nuevo catálogo',
    })
  } catch (error) {
    notifications({ ex: error })
  } finally {
    yield put({ type: CATALOGOS_SET_IS_NEW, payload: false })
  }
}

function* watchGetCatalogoListaSeleccion(): Generator {
  yield takeEvery(CATALOGOS_GET_LISTASELECCION, getCatalogoListaSeleccion)
}

function* watchGetEstados(): Generator {
  yield takeEvery(CATALOGOS_GET_ESTADO, getCatalogoEstados)
}

function* watchNewListaSeleccion(): Generator {
  yield takeEvery(CATALOGOS_NEW_LISTA_SELECCION, postNewListaSeleccion)
}

export default function* CatalogosSaga(): Generator {
  yield all([fork(watchGetCatalogoListaSeleccion), fork(watchGetEstados), fork(watchNewListaSeleccion)])
}
